import { ICON__arrow_up } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_collections } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_6 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_6';
import { LOCAL__collection_set_current } from '@/state/collection/entity/local_collection_set_current';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';

export function BAR_BUTTON__collection_previous() {
  const dispatch = use_dispatch();

  const { collections_map, collection_current } = use_slice_collections(['collections_map', 'collection_current']);

  function onClick(e: React.MouseEvent) {
    let collections = Array.from(collections_map.values());
    collections = collections.filter(item => item.workspace_id == collection_current.workspace_id); //keep only collections from current workspace

    collections.sort(DTO__database_entity.sort_by_created_at_newest_first);

    let index = collections.findIndex(item => item._id == collection_current._id);

    let index_new = index - 1;

    if (index_new < 0) index_new = collections.length - 1;

    let collection_current_new = collections[index_new];

    dispatch(LOCAL__collection_set_current(collection_current_new._id));
  }

  /*
   *
   */

  if (Array.from(collections_map.values()).length <= 1) return <PLACEHOLDER_BUTTON__bar_6 />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      Icon={ICON__arrow_up}
      iconClassNameBase={`!text-component-item-foreground !size-4 !duration-300`}
      iconClassNameHovered="!text-bar-foreground"
      variant="no-border-on-component"
      {...{ onClick }}
      className={`p-0 rounded-lg  bg-bar  `}
    />
  );
}
